import * as Sentry from '@sentry/vue'
import { getCurrentEnvironment } from '@/config/firebase'

export function sentryInit({ app, router }) {
  if (getCurrentEnvironment() === 'prod') {
    Sentry.init({
      app,
      release: `owqlo-project-inscription@${__APP_VERSION__}`,
      dsn: "https://cd37354ac9f3321d3b66ccdd673cb78b@o4510347372593152.ingest.us.sentry.io/4512057208668160", // Ver con la cuenta de apps@owqlo.com
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration(),
      ],
      tracesSampleRate: 1.0,
      tracePropagationTargets: ["https://enrollment.owqlo.com"],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  }
}